import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-768a7d72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "listbox",
  class: "oxd-select-dropdown"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_select_option = _resolveComponent("oxd-select-option")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.empty)
      ? (_openBlock(), _createBlock(_component_oxd_select_option, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.placeholderText), 1)
          ]),
          _: 1
        }))
      : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
  ]))
}